import { ActionTimeline } from './action-timeline'
import { classificationReasons, type ClassificationRun } from './run-display'
import type { ClassificationConfig } from './config'
import { Assessments } from './assessments'
import { ClassificationResultView } from './result'

export function ClassificationRunDetails({
  classification,
}: {
  classification: ClassificationRun
  config?: ClassificationConfig
}) {
  return (
    <div className="sentry-block ph-no-capture space-y-5">
      {classification.reason && !classification.actions.some(action => action.reason === classification.reason) && (
        <p className="text-sm">
          {classificationReasons[classification.reason]}
        </p>
      )}
      <ActionTimeline actions={classification.actions} decisions={classification.decisions} />
      {!classification.reason && classification.result?.error && <ClassificationResultView result={classification.result} />}
      <Assessments result={classification.result ?? null} />
    </div>
  )
}
